
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ProductYdnPi9q5S0PVvUMzSmq78sB0D036H_DbPsOCjmpMOk0Meta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Product.vue?macro=true";
import { default as CategoryHCseXk0wxT6vr_45fUsrvIowtn5KKCQKYr_7MlUhDSjUsMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Category.vue?macro=true";
import { default as ShippingTyHbA4xISC9F4vHLnUOumYaVvhG_45CifZm70Q4OSAX6YMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Shipping.vue?macro=true";
import { default as SwitchViewv9fckf7mDNyjRRnXqmn0HAZFkWOef0cMVipAMEexEf4Meta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/SwitchView.vue?macro=true";
import { default as Billing6G43Xnv78IAuRYwNX_oL_45eQ8nxTL8TKhIAKCZaMTgqkMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Billing.vue?macro=true";
import { default as PaymentCqf4byqIhswgvYwn67soE7UywfchV1OBUtjHEYhU5YIMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Payment.vue?macro=true";
import { default as ThankYouLpFG7oCIGJ_45aCxRPHi0r_45we4nHpnnhWrpHOSo3AyEw8Meta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/ThankYou.vue?macro=true";
import { default as Checkout68PzCwWqd_45ggSUxJZrC13Q07QgJ4DuykMCstKtOmvkUMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout.vue?macro=true";
import { default as MyAccountIhToi3z5FQKKMU6pQu5jeRNnmEC43JafuwMHuqP_453jIMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount.vue?macro=true";
import { default as _91id_936n68mmgua4QuklqgiG9CIBjRJaA9THJnx0yBd2y8kVkMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/[id].vue?macro=true";
import { default as Cart_YmWvLkPyWuh5SjNDXXd1rf7W7OfBvaO_45IiO_zflS2EMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Cart.vue?macro=true";
import { default as RegisterM2aUc6DpneBOlFhleIySmPQEFlBr_45pu58UtRoZpZRZoMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Register.vue?macro=true";
import { default as WishlistLkXSLvYf92ZO7xY35hvOdZ180Gt584WnuJR5J2MFoykMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Wishlist.vue?macro=true";
import { default as MyProfilezT6T1rpuUmg1IYN2_45HEgfbI1hEVFNNsl9Fmz_458RLUo4Meta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/MyProfile.vue?macro=true";
import { default as OrderDetailsaJkPs9I3c0MrsCIx6AN5Z6gcGznSPMUsaACr1j102xoMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/OrderDetails.vue?macro=true";
import { default as OrderHistory_45zdTZEsM9SEv05po6DnKuN_J_mLMP7gBqIzcbpsDip0Meta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/OrderHistory.vue?macro=true";
import { default as CreateReturnsruF224O6Zn4pJZl0qxQoT0xpkAS97LfBXyq_45f9jYmgoMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/CreateReturns.vue?macro=true";
import { default as DeleteProfileox6h4z8oGUB4uSj6oq0LR6bgPKOBle9zxhRLp23ac5AMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/DeleteProfile.vue?macro=true";
import { default as ReturnDetailsLHR57uRfsLk_Oxbtk40orKifckzjJn81snGwc4MotZIMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/ReturnDetails.vue?macro=true";
import { default as BillingDetailsCTXNB_45auosZwrWF41vzjtq8vahbq6250pkb4lQyQEbAMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/BillingDetails.vue?macro=true";
import { default as ReturnsOverview1Aw3ZRT47FewYEwiqpmrd0gtPhgI_45yK8bC3dPs2y_OQMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/ReturnsOverview.vue?macro=true";
import { default as ShippingDetailsgaWt0rEaAYEJwcp4GxjL5A3xAESQ_45DwOvOlZ_PnVsogMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/ShippingDetails.vue?macro=true";
import { default as FilialfinderTBeeIy_sIxggSzPyaSqkO3vFm7RjdO9s_G23sOpVnCwMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Filialfinder.vue?macro=true";
import { default as ResetPassword7ETdgZQqumA1MV_45vtzNaqjZcrOrnd_2AgcTx_45AbmrpMMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/ResetPassword.vue?macro=true";
import { default as PreferredFilialO1K82P5nDHuQ8q1zxwJfigyyX9rLuy3p8ATkLnChUe4Meta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/PreferredFilial.vue?macro=true";
import { default as GuestCreateReturn5Uz4yjC6ORDY7KkjNK0P7psmcVaxSEthoGjq02osEo4Meta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/GuestCreateReturn.vue?macro=true";
import { default as GuestOrderDetails7aoUClieKTeugH3Uj8UP_45AgHhwZF_I11fWH4zgiThQIMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/GuestOrderDetails.vue?macro=true";
import { default as GuestReturnDetailsqmFcVX6ijaqrLjCKQnWTXe6vVHXleAZLF61n_45l6p_mQMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/GuestReturnDetails.vue?macro=true";
export default [
  {
    name: "product",
    path: "/p/:slug/:id",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Product.vue")
  },
  {
    name: "category-new",
    path: "/c/n/:type/:slug_1?/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    meta: {"isNew":true},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Category.vue")
  },
  {
    name: "category-sale",
    path: "/c/s/:type/:slug_1?/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    meta: {"isSale":true},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Category.vue")
  },
  {
    name: "category",
    path: "/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Category.vue")
  },
  {
    name: "search",
    path: "/search/:slug_2?",
    meta: {"isSearch":true},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Category.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: {"layout":"checkout","middleware":["cart-not-empty"]},
    redirect: "/checkout/cart",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout.vue"),
    children: [
  {
    name: "shipping",
    path: "shipping",
    meta: {"layout":"checkout"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Shipping.vue")
  },
  {
    name: "shipping-customer",
    path: "shipping-customer",
    meta: {"layout":"checkout","type":"customer"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Shipping.vue")
  },
  {
    name: "shipping-guest",
    path: "shipping-guest",
    meta: {"layout":"checkout","type":"guest"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Shipping.vue")
  },
  {
    name: "shipping-new-customer",
    path: "shipping-new-customer",
    meta: {"layout":"checkout","type":"new-customer"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Shipping.vue")
  },
  {
    name: "switchView",
    path: "switchView",
    meta: {"layout":"checkout","middleware":["switch-view-redirect"]},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/SwitchView.vue")
  },
  {
    name: "billing",
    path: "billing",
    meta: {"layout":"checkout","type":"guest"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Billing.vue")
  },
  {
    name: "billing-customer",
    path: "billing-customer",
    meta: {"layout":"checkout","type":"customer"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Billing.vue")
  },
  {
    name: "billing-guest",
    path: "billing-guest",
    meta: {"layout":"checkout","type":"guest"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Billing.vue")
  },
  {
    name: "billing-new-customer",
    path: "billing-new-customer",
    meta: {"layout":"checkout","type":"new-customer"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Billing.vue")
  },
  {
    name: "payment-customer",
    path: "payment-customer",
    meta: {"layout":"checkout","type":"customer"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Payment.vue")
  },
  {
    name: "payment-new-customer",
    path: "payment-new-customer",
    meta: {"layout":"checkout","type":"new-customer"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Payment.vue")
  },
  {
    name: "payment-guest",
    path: "payment-guest",
    meta: {"layout":"checkout","type":"guest"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Payment.vue")
  },
  {
    name: "payment",
    path: "payment",
    meta: {"layout":"checkout"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Payment.vue")
  },
  {
    name: "thank-you",
    path: "thank-you",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/ThankYou.vue")
  }
]
  },
  {
    name: "my-account",
    path: "/my-account/:pageName?",
    meta: {"middleware":["is-authenticated"]},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount.vue")
  },
  {
    path: "/signin",
    name: "signin",
    meta: {"middleware":["mykik-app-signin"]}
  },
  {
    name: "home",
    path: "/:catchall(.*)",
    meta: _91id_936n68mmgua4QuklqgiG9CIBjRJaA9THJnx0yBd2y8kVkMeta || {},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/[id].vue")
  },
  {
    name: "Cart",
    path: "/Cart",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Cart.vue")
  },
  {
    name: "Product",
    path: "/Product",
    meta: ProductYdnPi9q5S0PVvUMzSmq78sB0D036H_DbPsOCjmpMOk0Meta || {},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Product.vue")
  },
  {
    name: "Category",
    path: "/Category",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Category.vue")
  },
  {
    name: "Checkout",
    path: "/Checkout",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout.vue"),
    children: [
  {
    name: "Checkout-Billing",
    path: "Billing",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Billing.vue")
  },
  {
    name: "Checkout-Payment",
    path: "Payment",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Payment.vue")
  },
  {
    name: "Checkout-Shipping",
    path: "Shipping",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Shipping.vue")
  },
  {
    name: "Checkout-ThankYou",
    path: "ThankYou",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/ThankYou.vue")
  },
  {
    name: "Checkout-SwitchView",
    path: "SwitchView",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/SwitchView.vue")
  }
]
  },
  {
    name: "Register",
    path: "/Register",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Register.vue")
  },
  {
    name: "Wishlist",
    path: "/Wishlist",
    meta: {"middleware":["is-authenticated"]},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Wishlist.vue")
  },
  {
    name: "MyAccount",
    path: "/MyAccount",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount.vue"),
    children: [
  {
    name: "MyAccount-MyProfile",
    path: "MyProfile",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/MyProfile.vue")
  },
  {
    name: "MyAccount-OrderDetails",
    path: "OrderDetails",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/OrderDetails.vue")
  },
  {
    name: "MyAccount-OrderHistory",
    path: "OrderHistory",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/OrderHistory.vue")
  },
  {
    name: "MyAccount-CreateReturns",
    path: "CreateReturns",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/CreateReturns.vue")
  },
  {
    name: "MyAccount-DeleteProfile",
    path: "DeleteProfile",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/DeleteProfile.vue")
  },
  {
    name: "MyAccount-ReturnDetails",
    path: "ReturnDetails",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/ReturnDetails.vue")
  },
  {
    name: "MyAccount-BillingDetails",
    path: "BillingDetails",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/BillingDetails.vue")
  },
  {
    name: "MyAccount-ReturnsOverview",
    path: "ReturnsOverview",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/ReturnsOverview.vue")
  },
  {
    name: "MyAccount-ShippingDetails",
    path: "ShippingDetails",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/ShippingDetails.vue")
  }
]
  },
  {
    name: "filialfinder",
    path: "/filialfinder",
    meta: FilialfinderTBeeIy_sIxggSzPyaSqkO3vFm7RjdO9s_G23sOpVnCwMeta || {},
    alias: ["/znajdz-sklep","/filiaalzoeker","/vyhledat-prodejnu"],
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Filialfinder.vue")
  },
  {
    name: "ResetPassword",
    path: "/ResetPassword",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/ResetPassword.vue")
  },
  {
    name: "preferredfilial",
    path: "/preferredfilial",
    meta: PreferredFilialO1K82P5nDHuQ8q1zxwJfigyyX9rLuy3p8ATkLnChUe4Meta || {},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/PreferredFilial.vue")
  },
  {
    name: "GuestCreateReturn",
    path: "/GuestCreateReturn",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/GuestCreateReturn.vue")
  },
  {
    name: "GuestOrderDetails",
    path: "/GuestOrderDetails",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/GuestOrderDetails.vue")
  },
  {
    name: "GuestReturnDetails",
    path: "/GuestReturnDetails",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/GuestReturnDetails.vue")
  }
]